export enum APPLICATION_ROUTES {
  ACCOUNT_CREATION_COMPLETED = '/account-creation-steps/completed',
  ACCOUNT_CREATION_PROCESSING = '/account-creation-steps/processing',
  ACTIVE_USE = '/activate-user/:token',
  ACTIVE_USE_FAIL = '/activate-user-fail',
  ACTIVE_USE_SUCCESS = '/activate-user-success',
  ASSIGN_PRIVACY = '/privacy/:privacySeqNr',
  ASSIGN_TERMS_OF_USE = '/terms-of-use/:termSeqNr',
  CLINICAL_NOTES = '/results-portal/patient/encounters/clinical-notes',
  CLINICAL_NOTES_DESCRIPTION = '/results-portal-service/patients/encounters/clinical-notes/:cdEvolucao/description',
  CLINICAL_NOTES_LIST = '/results-portal-service/patients/encounters/clinical-notes/see-clinical-notes',
  EXAM_DETAILS = '/results/exams/nonlab/details/:patientId',
  EXAM_LAB_DETAILS = '/results/exams/lab/details/:patientId',
  EXAMS_RESULTS = '/results/exam-results',
  EXAMS_RESULTS_PATIENT = '/results/exam-results/:patientId',
  FORGET_PASSWORD = '/login/forget-password',
  FORGET_PASSWORD_REQUEST_FAILURE = '/forget-password/failure',
  FORGET_PASSWORD_REQUEST_EMAIL_NOT_FOUND = '/forget-password/email-not-found',
  FORGET_PASSWORD_REQUEST_SUCCESS = '/forget-password/success',
  FORGET_PASSWORD_RESET_FAILURE = '/reset-password-failure',
  FORGET_PASSWORD_RESET_SUCCESS = '/reset-password-success',
  LISTA_AVISO_DE_PRIVACIDADE = '/results-portal-service/:nrSeqBeneficiario/lista-aviso-de-privacidade',
  LISTA_TERMOS_DE_USO = '/results-portal-service/:nrSeqBeneficiario/lista-termos-de-uso',
  LOGIN = '/login',
  LOGOUT_INACTIVITY = '/inactivity',
  NEW_PASSWORD = '/new-password/:token',
  NEW_USER = '/account-creation-steps',
  NEW_USER_BY_LOGIN = '/results/users/new-user-by-login',
  NEW_USER_BY_LOGIN_COMPLETED = '/results/users/new-user-by-login/completed',
  NEW_USER_BY_LOGIN_PROCESSING = '/results/users/new-user-by-login/processing',
  PASSWORD_RECOVERY_SUCCESS = '/password-recovery-success',
  PATIENT_LIST = '/results/patient-list',
  PRIVACY_AND_TERMS = '/results/privacy-and-terms',
  PROFILE = '/results/profile',
  PROFILE_CHANGE_PASSWORD = '/results/change-password',
  RESET_PASSWORD = '/reset-password',
  RESULTS_PORTAL = '/results-portal',
  RESULTS_PORTAL_ROOT = '/results',
  USERS = '/results/users',
  USER_PROFILE = '/results/users/user-profile',
}
